<template>
  <div style="align-content: center">
    <template v-if="row.zip_code">
      <strong><translate-text keyTranslate="common_words.zip_code" />: </strong>
      {{ row.zip_code ? row.zip_code : 'NA' }}
      <br />
    </template>
    <strong><translate-text keyTranslate="common_words.address" />: </strong>
    {{ row.address ? row.address : 'NA' }}
    <br />
    <strong><translate-text keyTranslate="common_words.country" />: </strong>
    {{ row.country }}
    <br />
    <strong><translate-text keyTranslate="common_words.state" />: </strong>
    {{ row.state }}
    <br />
    <strong><translate-text keyTranslate="common_words.city" />: </strong>
    {{ row.city }}
    <br />
  </div>
</template>

<script>
export default {
  name: 'AddressFormatter',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
};
</script>
